{
  "nl": {
    "session": {
      "error_internalserver": {
        "goback": "Ga terug",
        "subtitle": "Oops, er is een onverwachte fout opgetreden.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Ga terug",
        "subtitle": "Sorry, de pagina die je zoekt kan niet gevonden worden.",
        "title": "404"
      },
      "expired": {
        "text": "De sessie is verlopen vanwege inactiviteit. Om veiligheidsredenen moet je opnieuw inloggen. \n\nKlik op OK om naar het inlogscherm te worden doorgestuurd.",
        "title": "Sessie verlopen."
      },
      "logout_impersonate": {
        "text": "Een logout actie werd geactiveerd tijdens een impersonatie.",
        "title": "Impersonatie gestopt."
      },
      "noaccess": {
        "text": "Onze meest recente <b>update</b> kan gevolgen hebben voor u: <p></p> <ul> <li>&nbsp;</li> <li><b>Teamleden en partners</b> hebben vanaf nu toegang (en kunnen inloggen) via <b>ziggu.app</b> (ipv <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Klanten</b> ondervinden geen gevolgen en kunnen het platform nog steeds bereiken via <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Klik op OK om doorgestuurd te worden naar de juiste pagina.</p> <p>Blijf je problemen ondervinden, neem dan contact op.</p>",
        "title": "Oeps.. je hebt geen toegang (meer) tot deze pagina."
      }
    }
  }
}